"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AddLink_1 = __importDefault(require("@mui/icons-material/AddLink"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const react_1 = __importStar(require("react"));
const EditorButton_1 = __importDefault(require("./EditorButton"));
const __1 = require("../..");
const react_final_form_1 = require("react-final-form");
const utils_1 = require("../utils");
const required = (value) => (value ? undefined : 'Required');
const CreateLinkButton = ({ disabled, editor }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const handleOpen = () => {
        if (disabled) {
            return;
        }
        setIsOpen(true);
    };
    const handleClose = () => setIsOpen(false);
    const handleCreate = (values, form) => {
        if (disabled) {
            return;
        }
        (0, utils_1.chainFocus)(editor, (chain) => chain.insertContent(`<link href="${values.link_url}" text="${values.link_text}" />`));
        handleClose();
        form.reset();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(EditorButton_1.default, { disabled: disabled, onClick: handleOpen },
            react_1.default.createElement(AddLink_1.default, null)),
        react_1.default.createElement(react_final_form_1.Form, { initialValues: { link_url: '', link_text: '' }, onSubmit: handleCreate }, ({ handleSubmit, submitting, hasValidationErrors }) => (react_1.default.createElement(__1.Dialog, { actions: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.Button, { variant: "outlined", disabled: submitting, onClick: handleClose }, "Close"),
                react_1.default.createElement(__1.Button, { "data-testid": "submit-link-button", variant: "contained", disabled: hasValidationErrors || submitting, onClick: handleSubmit }, "Create")), content: react_1.default.createElement(Grid_1.default, { container: true, spacing: 3 },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(react_final_form_1.Field, { name: "link_url", validate: required }, ({ input }) => react_1.default.createElement(TextField_1.default, { fullWidth: true, ...input, label: "Link URL" }))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(react_final_form_1.Field, { name: "link_text", validate: required }, ({ input }) => react_1.default.createElement(TextField_1.default, { fullWidth: true, ...input, label: "Link Text" })))), open: isOpen, title: "Add Link" })))));
};
exports.default = CreateLinkButton;
